import { layout, media } from 'src/components/base';
import { StoreLogo } from 'src/components/store-logo';
import {
  Card as CardComponent,
  CardContent,
  CardMedia,
} from '@prisjakt/ui/card';
import { Row } from '@prisjakt/ui/list/variants';
import RatingComponent from 'src/components/rating';
import styled, { css, keyframes } from 'styled-components';

import { Dropdown as DropdownContainer } from '@prisjakt/ui/dropdown';

interface ICard {
  background?: boolean;
}
export const Card = styled(CardComponent)<ICard>`
  height: 100%;
  ${p =>
    p.background &&
    css`
      background-color: ${p.theme.bg.primary};
    `}
`;

export const Content = styled(CardContent)`
  flex: 1 1 auto;
  text-align: initial;
  padding-top: 0;
  word-break: break-word;
`;

export const ActionButton = styled.div`
  position: absolute;
  top: ${layout.measurements.spacing100};
  right: ${layout.measurements.spacing100};
  display: flex;
  flex-direction: column;

  > *:not(:first-child) {
    margin-top: ${layout.measurements.spacing100};
  }
`;

export const PriceInfo = styled.div``;

export const Properties = styled.div(
  props => `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`
);

export const Rating = styled(RatingComponent)`
  margin-bottom: ${layout.measurements.spacing050};
`;

type MediaProps = {
  $size: string;
};

export const Media = styled(CardMedia)<MediaProps>`
  overflow: visible;
  height: ${p => p.$size};
  margin: ${layout.measurements.spacing100} 0;

  &::after {
    background-color: transparent;
  }
`;

export const DiffPercentageCore = styled.div`
  background: ${p => p.theme.colors.redio500};
  padding: 0.1rem 0.4rem;
  border-radius: 2px;

  ${media.mediumUp`
    top: ${layout.productCardPaddingLarge};
    left: ${layout.productCardPaddingLarge};
  `}
`;

export const DiffPercentage = styled(DiffPercentageCore)`
  position: absolute;
  top: ${layout.productCardPaddingSmall};
  left: ${layout.productCardPaddingSmall};
`;

export const PriceWrapper = styled(Row)<{
  isKWLP?: boolean;
}>`
  && {
    align-items: center;
    flex: 0 1 auto;
    width: 100%;
    ${p => p.isKWLP && 'justify-content: space-between'}
  }
`;

export const StyledPrice = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
`;

export const BrandLogo = styled.img`
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: ${layout.measurements.spacing100};
  max-height: 20px;
`;

export const ShopLogo = styled(StoreLogo)`
  margin-right: ${layout.measurements.spacing050};
`;

export const ClickOutFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ReportOverlay = styled.div`
  color: ${p => p.theme.text.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 250ms ease-in-out 1;
  width: 100%;
`;

export const Options = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`;

export const Option = styled.button`
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  padding: ${layout.measurements.spacing050};

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const Dropdown = styled(DropdownContainer)`
  min-height: 100%;
  margin-right: ${layout.measurements.spacing050};
`;
